import { Group, Spinner, Text } from '@optiaxiom/react';
import styles from './ApiKeyEmptyState.module.css';

/**
 * Shown while the API-key status request (GET /dev-portal/api-keys) is in flight,
 * so the page isn't blank until the backend responds.
 */
export function ApiKeyLoading() {
  return (
    <Group alignItems="center" flexDirection="column" className={styles.container}>
      <Spinner />
      <Text color="fg.secondary">Checking your API key…</Text>
    </Group>
  );
}
